import { render } from "./SectionHeading.vue?vue&type=template&id=0870512c&scoped=true"
import script from "./SectionHeading.vue?vue&type=script&lang=js"
export * from "./SectionHeading.vue?vue&type=script&lang=js"

import "./SectionHeading.vue?vue&type=style&index=0&id=0870512c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0870512c"]])

export default __exports__